import { render, staticRenderFns } from "./EditPredictedTransaction.vue?vue&type=template&id=6a404730&"
import script from "./EditPredictedTransaction.vue?vue&type=script&lang=js&"
export * from "./EditPredictedTransaction.vue?vue&type=script&lang=js&"
import style0 from "./EditPredictedTransaction.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports